import { render, staticRenderFns } from "./SummarySingle.vue?vue&type=template&id=fa7f31ca&scoped=true&"
import script from "./SummarySingle.vue?vue&type=script&lang=js&"
export * from "./SummarySingle.vue?vue&type=script&lang=js&"
import style0 from "./SummarySingle.vue?vue&type=style&index=0&id=fa7f31ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa7f31ca",
  null
  
)

export default component.exports